import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RouterProvider, createHashRouter } from 'react-router';
import { RecoilRoot } from 'recoil';
import { GlobalEffects } from './components/Effects';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { StreamPage } from './pages/StreamPage';
const router = createHashRouter([
    {
        element: _jsx(Layout, {}),
        children: [
            {
                path: '/',
                element: _jsx(HomePage, {}),
            },
            {
                path: '/stream/:streamId',
                element: _jsx(StreamPage, {}),
            },
        ],
    },
    {
        path: '/embed/:streamId',
        element: _jsx(StreamPage, { embedded: true }),
    },
]);
export function App() {
    return (_jsxs(RecoilRoot, { children: [_jsx(GlobalEffects, {}), _jsx(RouterProvider, { router: router })] }));
}
